export enum CompanyType {
  Partner = 0,
  Customer = 1,
}

export namespace CompanyType {
  export function GetAllTypes(): CompanyType[] {
    return [CompanyType.Partner, CompanyType.Customer];
  }
}
